"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggleWrapper = exports.StyledToggleBox = exports.StyledToggleLabel = exports.StyledToggle = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
exports.StyledToggle = styled_components_1.default.input `
  visibility: hidden;
  position: absolute;
  margin-left: -9999px;
`;
exports.StyledToggleLabel = styled_components_1.default.label `
  display: block;
  position: relative;
  cursor: pointer;
  outline: none;
  user-select: none;
  width: ${theme_1.spacings.s9};
  height: ${(0, utils_1.pxToRem)(28)};
  border-radius: ${(0, utils_1.pxToRem)(500)};

  &::before,
  &::after {
    position: absolute;
    top: 3px;
    left: 3px;
    bottom: 3px;
    content: '';
  }

  &::before {
    background-color: ${theme_1.grayScale[600]};
    border-radius: 60px;
    transition: all 0.4s;
  }

  &::after {
    width: ${(0, utils_1.pxToRem)(22)};
    height: ${(0, utils_1.pxToRem)(22)};
    background-color: ${theme_1.grayScale[100]};
    border-radius: ${(0, utils_1.pxToRem)(500)};
    transition: all 0.4s;
  }
`;
exports.StyledToggleBox = (0, styled_components_1.default)(flexbox_1.Flexbox)(({ isActive }) => {
    return (0, styled_components_1.css) `
    margin: 0 auto;
    width: ${theme_1.spacings.s9};
    height: ${(0, utils_1.pxToRem)(28)};
    border-radius: ${(0, utils_1.pxToRem)(500)};
    background-color: ${theme_1.grayScale[600]};
    transition: all 0.2s;

    ${isActive &&
        (0, styled_components_1.css) `
      background-color: ${theme_1.primary.light};
      ${exports.StyledToggleLabel}::before {
        background-color: ${theme_1.primary.light};
      }
      ${exports.StyledToggleLabel}::after {
        transform: translateX(20px);
      }
    `}
  `;
});
exports.StyledToggleWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  padding: 4px;
  transition: all 0.2s;

  &:focus-visible,
  &:focus-within {
    box-shadow: ${theme_1.shadows.containedFocus(theme_1.primary.dark, theme_1.primary.dark)};
    border-radius: ${theme_1.spacings.s1};
  }
`;
//# sourceMappingURL=styles.js.map